// src/pages/TermsPage.jsx
import React from "react";
import { useTranslation } from "react-i18next";

const TermsPage = () => {
  const { t } = useTranslation();

  return (
    <main className="mx-auto max-w-3xl px-4 py-10 text-sm text-slate-800 sm:px-6 lg:px-8">

      <h1 className="text-2xl font-semibold text-slate-900 sm:text-3xl">
        {t("legal.terms.title")}
      </h1>

      <p className="mt-2 text-[12px] text-slate-500">
        {t("legal.lastUpdated", { year: new Date().getFullYear() })}
      </p>

      {/* Section 0 – intro */}
      <p className="mt-6 text-[13px] leading-relaxed">
        {t("legal.terms.intro")}
      </p>

      {/* Dynamic sections */}
      {[1,2,3,4,5,6,7,8,9,10].map((num) => (
        <section key={num} className="mt-6 space-y-4">
          <h2 className="text-lg font-semibold text-slate-900">
            {t(`legal.terms.${num}.title`)}
          </h2>

          <p className="text-[13px] leading-relaxed">
            {t(`legal.terms.${num}.body1`)}
          </p>

          {/* Optional second paragraph */}
          {t(`legal.terms.${num}.body2`, "") && (
            <p className="text-[13px] leading-relaxed">
              {t(`legal.terms.${num}.body2`)}
            </p>
          )}

          {/* Optional bullet list */}
          {t(`legal.terms.${num}.list.0`, "") && (
            <ul className="ml-5 list-disc text-[13px] leading-relaxed">
              {Array.from({ length: 10 }).map((_, index) => {
                const item = t(`legal.terms.${num}.list.${index}`, "");
                return item ? <li key={index}>{item}</li> : null;
              })}
            </ul>
          )}
        </section>
      ))}

      {/* Contact */}
      <section className="mt-6 mb-10 space-y-4">
        <h2 className="text-lg font-semibold text-slate-900">
          {t("legal.terms.contactTitle")}
        </h2>
        <p className="text-[13px] leading-relaxed">
          {t("legal.terms.contactBody")}
        </p>

        <a
          href="mailto:support@cerebrumlux.com"
          className="text-teal-600 underline text-[13px]"
        >
          support@cerebrumlux.com
        </a>
      </section>
    </main>
  );
};

export default TermsPage;
